<template>
  <p class="text-caption q-ml-lg q-mt-md">
    <q-skeleton type="text" style="width: 120px; line-height: 1em" />
  </p>
  <q-item
    v-for="i in loaderCount"
    :key="`loader-${i}`"
    class="q-px-lg relative-position"
    style="max-width: 500px"
  >
    <q-item-section side class="flex flex-center">
      <q-skeleton type="QBtn" size="40px" />
    </q-item-section>

    <q-item-section class="col q-py-xs q-pr-sm q-pl-none">
      <q-item-label>
        <q-skeleton type="text" style="width: 400px" />
      </q-item-label>
      <q-item-label caption>
        <q-skeleton type="text" style="width: 100px" />
      </q-item-label>
    </q-item-section>
  </q-item>
</template>

<script setup lang="ts">
// PROPS
defineProps<{
  loaderCount: number
}>()
</script>

<style lang="scss" scoped>
.notif-border-left {
  opacity: 0.15;
  border: solid 4px;
  border-top-left-radius: inherit !important;
  border-bottom-left-radius: inherit !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
</style>
